export const CONDITION_ID_PARAM_NAME = 'conditionId';
